import { IconButton, makeStyles } from '@material-ui/core'
import { FilterChip } from 'asterX-UI/Inputs'
import React, { useState } from 'react'
import { FilterSimplifiedIcon } from 'asterX-UI/Icons'
import { GRAY_COLORS } from 'asterX-UI'
import FilterDialog from './FilterDialog'
import { Modal } from 'asterX-UI/Modals'
import { useFilterStore } from 'context/SelectionStore/Manager/FilterStoreProvider.mager'

const useStyle = makeStyles(theme => ({
  rootDiv: {
    display: 'flex',
    overflowX: 'auto',
    gap: 6,
    '&::-webkit-scrollbar': {
      display: 'none!important'
    },
    marginTop: 8
  }
}))
const FilterPanel = () => {
  const {
    dictionary,
    store: { filter },
    func: { onChangeFilterChip }
  } = useFilterStore()
  const classes = useStyle()
  const maxWidth = window.innerWidth - 16
  const [isFilterFullOPen, setIsFilterFullOPen] = useState(false)

  const onChange = e => {
    const { name, value } = e.target
    if (name === 'keyNumber') {
      return onChangeFilterChip({
        [name]:
          value
            ?.toString()
            ?.toLowerCase()
            .replace(/[^0-9]+/g, '') || ''
      })
    }
    onChangeFilterChip({ [name]: value })
  }
  const onChangeRange = e => {
    const { name, value } = e.target
    if (name === 'price') {
      return onChangeFilterChip({
        minPrice: value?.min,
        maxPrice: value?.max
      })
    }
    if (name === 'mileage') {
      return onChangeFilterChip({
        minMileage: value?.min,
        maxMileage: value?.max
      })
    }
    if (name === 'mileage') {
      return onChangeFilterChip({
        minMileage: value?.min,
        maxMileage: value?.max
      })
    }
  }
  return (
    <div className={classes.rootDiv} style={{ maxWidth }}>
      <IconButton
        style={{
          color: GRAY_COLORS['700']
        }}
        onClick={() => setIsFilterFullOPen(true)}
        size={'small'}
      >
        <FilterSimplifiedIcon />
      </IconButton>
      <FilterChip
        type={'MULTI_SELECT'}
        label={'Филиал'}
        labelKey={'name'}
        value={filter.branchCodes}
        hasSelectAll
        valueKey={'code'}
        onChange={onChange}
        options={dictionary.branchList}
        name={'branchCodes'}
      />
      <FilterChip
        type={'RANGE'}
        label={'Цена'}
        textType={'phone'}
        value={{ min: filter?.minPrice, max: filter?.maxPrice }}
        onChange={onChangeRange}
        name={'price'}
        rangeLabel={['Цена от', 'Цена до']}
      />
      <FilterChip
        type={'RANGE'}
        label={'Пробег'}
        value={{ min: filter?.minMileage, max: filter?.maxMileage }}
        onChange={onChangeRange}
        textType={'phone'}
        name={'mileage'}
        rangeLabel={['Пробег от', 'Пробег до']}
      />
      <FilterChip
        type={'SELECT'}
        label={'Марка'}
        name={'markaNew'}
        labelKey={'name'}
        valueKey={'id'}
        options={dictionary.brands}
        value={filter?.markaNew}
        onChange={onChange}
      />
      <FilterChip
        type={'SELECT'}
        label={'Модель'}
        name={'modelNew'}
        labelKey={'name'}
        valueKey={'id'}
        options={dictionary.models}
        value={filter?.modelNew}
        onChange={onChange}
      />
      <FilterChip
        type={'INPUT'}
        label={'Номер ключа'}
        name={'keyNumber'}
        value={filter?.keyNumber}
        onChange={onChange}
      />
      <FilterChip
        type={'INPUT'}
        label={'Код товара'}
        name={'oneCId'}
        value={filter?.oneCId}
        onChange={onChange}
      />

      <Modal
        fullWidth
        maxWidth={'md'}
        open={isFilterFullOPen}
        onClose={() => setIsFilterFullOPen(false)}
      >
        <FilterDialog setIsFilterFullOPen={setIsFilterFullOPen} />
      </Modal>
    </div>
  )
}

export default FilterPanel
